import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Redirect } from 'react-router'
import {ChainSorter} from 'chainsorter';

import ReceiptForm from '../components/harvest/receiptinterface.js';
import Loadable from '../components/ui/loading/Loadable.js';
import RecordSummary from '../components/harvest/recordsummary.js';
import Weight from '../components/ui/Weight.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faPlus } from '@fortawesome/free-solid-svg-icons'

import convert from 'convert-units';
import api from '../api/index.js';

import './Dashboard.scss'
import './ProcessorReceipts.scss'

export default (props) => {

	const [data, setData] = useState(false);
	const [records, setRecords] = useState([]);
	const [processor, setProcessor] = useState(false);
	const [extraRecords, setExtraRecords] = useState(false);
	const [units, setUnits] = useState(false);
	const [redirect, setRedirect] = useState(false);
	const [notFound, setNotFound] = useState(false);

	const refresh = async () => {
		try {
			setNotFound(false);
			setUnits(await api.settings.get('display_units_mass'));
			let d = await api.get('harvests/receipts/' + props.match.params.receipt_id + '?processor=' + props.match.params.processor_id + '&from=' + props.dateStart.api() + '&until=' + props.dateEnd.api());

			if (d['receipts'].length > 0) {
				setData(d['receipts'][0]);
				setRecords(d['receipts'][0]['records']);
			} else {
				setNotFound(true);
			}
			
			let extra = d['unassociated_records'];
			ChainSorter(extra).desc('date').sort();
			setExtraRecords(extra);

			setProcessor(d['processor']);

		} catch(e) {
			console.log("hello", e);
			api.handleExceptions(e);
		};
	}


	useEffect(()=>{
		refresh();
	}, [props.dateStart, props.dateEnd])


	const saveLinks = () => {
		
	}

	const onSaved = () => {
		refresh();
		// setRedirect('/processors/' + props.match.params.processor_id + '/receipts/' + a);
		return true;
	}
	
	const onAdded = (a) => {
		// This shouldn't ever be called, but just in case. I'm just going to assume the processor id is the same
		setRedirect('/processors/' + props.match.params.processor_id + '/receipts/' + a);
	}

	const addRecord = (i, index) =>	 {
		console.log("adding record", i);
		setRecords(records.concat([i]));

		extraRecords.splice(index, 1);
		setExtraRecords(extraRecords);
	}


	const removeRecord = (i, index) =>	 {
		setExtraRecords(extraRecords.concat([i]));

		records.splice(index, 1);
		setRecords(records);
	}


	if (redirect)
		return  <Redirect to={redirect} />

	const unassociatedWeight = extraRecords && extraRecords.reduce((a, c) => a + parseFloat(c.harvested), 0);
	const associatedWeight = records && records.reduce((a, c) => a + parseFloat(c.harvested), 0);

	return <div className="ProcessorReceipt Specific">
		<Loadable ready={extraRecords !== false} className="">
			{ !notFound && data && 
			<>
				<Link to={"/processors/" + props.match.params.processor_id + '/receipts'} title="Back">&laquo; Back to { processor.Name }'s Receipts</Link>
				<h1>Receipt # { data && data.hasOwnProperty('ReceiptNumber') && data.ReceiptNumber }</h1>
				<ReceiptForm date={api.date(data.Date)} recordId={data.HarvestReceiptID} invoice={data.ReceiptNumber} records={records} processor={data.ProcessorID} weight={data.Weight} onSaved={onSaved} onAdded={onAdded}>
					<h3 className="inline-weight">Associated Harvest Records ({ records &&
						<Weight value={associatedWeight} precision="0" />
					})</h3>
					<div className="members">
					{
						records && records.map((r, i) => {
							return <div key={i} className="record-summary box-style">
								<div className="action-button-holder" onClick={()=>removeRecord(r, i)}>
									<FontAwesomeIcon icon={faTimes} className="addEventListener" />
								</div>
								<div className="inner">
									<RecordSummary {...r} />
								</div>
							</div>;
						})
					}
					</div>
				</ReceiptForm>
				<hr />
				<h3 className="inline-weight" style={{'marginTop': '2em'}}>Unassociated Harvest Records ({ extraRecords &&
					<Weight value={unassociatedWeight} precision="0" />
				})</h3>
				<div className="members">
				{
					extraRecords && extraRecords.map((r, i) => {
						return <div key={i} className="record-summary box-style">
							<div className="action-button-holder" onClick={()=>addRecord(r, i)}>
								<FontAwesomeIcon icon={faPlus} className="addEventListener" />
							</div>
							<div className="inner">
								<RecordSummary {...r} />
							</div>
						</div>;
					})
				}
				</div>
			</>
			}
			{ notFound && <p>No receipt found. Are you in the right time range?</p> }
		</Loadable>
	</div>;
}